<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="500px" :before-close="handleClose"
		:close-on-click-modal="false">
		<el-form label-position="right" ref="addForm" :model="addForm" label-width="70px" class="postForm">
			<el-form-item label="赛季名称:" label-width="110px">
				<el-input v-model="addForm.seasonName" auto-complete="off" class="formItem" size="small"
					maxLength="200" />
			</el-form-item>
			<el-form-item label="年度:" label-width="110px">
				<el-date-picker value-format="yyyy"
					v-model="addForm.year"
					type="year"
					placeholder="选择年度">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="学期:" label-width="110px">
					<el-select v-model="addForm.term" placeholder="请选择" size="small">
					<el-option v-for="item in termDict" :key="item.valuekey" :label="item.textkey"
						:value="item.valuekey">
					</el-option>
				</el-select>
			</el-form-item>

		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="handleSubmit()" size="small">确 定</el-button>
		</div>
	</el-dialog>

</template>
<script>
export default {
	name: "addSave",
	props: ["showTitle", "dialogAddShow", "mid"],
	data() {
		return {
			addForm: {
				id: 0,
				seasonName: '',
				year: 0,
				term: 0,

			},
			termDict:[{valuekey:1,textkey:"上学期"},{valuekey:2,textkey:"下学期"}]
		};
	},
	watch: {
		dialogAddShow: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.initData();
				}
			},
			deep: true
		}
	},
	methods: {
		initData() {
			this.$axios.get("/exercise/getrankmatchseasoninfo?id=" + this.mid + "&rnd=" + new Date().getTime())
				.then(res => {
					this.addForm = res.data.data;
					if(this.addForm.id<=0){
						this.addForm.year=''
						this.addForm.term=''
					}
					else{
						this.addForm.year=String(this.addForm.year)
					}
				});
		},
		handleClose() {
			this.$emit("getVisible", false);
		},
		handleSubmit() {
			let formData = this.$util.jsonToForm(this.addForm);
			this.$axios.post("/exercise/rankmatchseasonsave", formData).then(res => {
				if (res.data.status == 0) {
					this.$message("保存成功!");
					this.$emit("saveCallBack");
				} else {
					this.$message(res.data.msg);
				}
			});
		}
	}
};
</script>

<style lang="less" scoped></style>
